import { render, staticRenderFns } from "./UserWelcomeent.vue?vue&type=template&id=9c09d3aa&"
import script from "./UserWelcomeent.vue?vue&type=script&lang=js&"
export * from "./UserWelcomeent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports